export default {
  field: {
    type: Object,
    default: () => {
      return {}
    }
  },

  value: {
    type: Object,
    default: () => {
      return {}
    }
  },

  moduleName: {
    type: String,
    default: null
  },

  labelText: {
    type: String,
    default: null
  },

  saveCallback: {
    type: Function,
    default: () => {}
  }
}
